import { useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { Course } from '@/domain/entities/course.entity'
import { ICourseService } from '@/services/contracts/courses'

type ListInstitutionsProps = {
  courseService: ICourseService
}

export function useUpdateCourse({ courseService }: ListInstitutionsProps) {
  const queryClient = useQueryClient()
  const { id } = useParams()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (course: Course) => courseService.update(course),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`list_institution`, id],
      })
    },
  })

  return {
    updateCourse: mutateAsync,
    isPending,
  }
}
